package com.essntl.uikit.components.radiobutton

import androidx.compose.material3.MaterialTheme
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import com.essntl.uikit.theme.esColorScheme

@Composable
fun EsPrimaryRadioButton(
    selected: Boolean,
    onSelectedChange: (Boolean) -> Unit,
    enabled: Boolean = true,
    loading: Boolean = false,
    modifier: Modifier = Modifier,
) {
    EsRadioButton(
        selected = selected,
        onSelectedChange = onSelectedChange,
        enabled = enabled,
        loading = loading,
        modifier = modifier,
        colors = EsRadioButtonColors(
            selectedColor = MaterialTheme.esColorScheme.primary,
            unselectedColor = MaterialTheme.esColorScheme.primary,
            disabledSelectedColor = MaterialTheme.esColorScheme.secondaryDisabled,
            disabledUnselectedColor = MaterialTheme.esColorScheme.secondaryDisabled,
        ),
    )
}